import { FlexWrapper, GapView, ParentDiv } from '../../styles/WrapperStyles'
import { React, useState, useRef, useEffect } from 'react'
import { styled, css } from 'styled-components'
import urls from "../../api/urls.json";
import Loader from "../Loader";
import { ImageDivFeedParent, ImageDivFeed, RotatImageIcon } from '../../styles/ImageWrapper';
import placeholder_image from '../../assests/placeholder_image.png'
import chrome_icon from '../../assests/chrome_icon.png';
import { CommonTextStyle } from '../../styles/TextStyles';
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import EmptyView from '../EmptyView';
import FeedDetailedProfileView from './FeedDetailedProfileView';
import { BaseButton } from '../../styles/ButtonStyles';
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import PageModal from '../modals/PageModal';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Feed.css';
import { detailedProfileViewPermission } from '../../access_levels';
import CropImage from '../CropImage';


const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;

const NameWrapper = styled.div`
  margin-left: 20px;
  margin-top: 50px;
`;

const GenderView = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 27.5px;
  background-color: #ec4655;
  margin-top: 40px;
  ${props =>
        props.male &&
        css`
      background-color: #50b3c5;
    `}
`;

const SelectedView = styled.button`
  width: 55px;
  height: 55px;
  border-radius: 27.5px;
  border: solid 5px #484848;
  color: #ffffff;
  background-color: #ffffff;
  margin-top: 20px;
  font-size: 20px;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;


const ChromeImageParent = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 35px;
  position: absolute;
  cursor: pointer;
  visibility: hidden;
  top: 85%;
  left: 3%;
  ${ImageDivFeedParent}:hover & {
    visibility: visible;
  }
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 200px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

const FeedbackWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
`;

const Feed = () => {
    const screenWidth = window.innerWidth;
    const isIpad = screenWidth === 1180;
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [apiPageChange, setApiPageChange] = useState(1);
    const [isLoading, setIsLoading] = useState(false)
    const [isDetailedView, setIsDetailedView] = useState(false);
    const totalPagesApi = useRef(0);
    const totalProfiles = useRef(0);
    const [profiles, setProfiles] = useState([]);
    const [profileStateTab, setProfileStateTab] = useState('Approve');
    const [reviewPassedRefs, setReviewPassedRefs] = useState([]);
    const [reviewFailedRefs, setReviewFailedRefs] = useState([]);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [showCropImage, setShowCropImage] = useState(false);
    const [imageUpdates, setImageUpdates] = useState([]);
    const [cropPhoto, setCropPhoto] = useState('')
    const accessLevel = localStorage.getItem('accessLevel');
    const profileState = {
        'Approve': 'approved',
        'Disapprove': 'disapproved',
        'Inapropriate': 'inappropriated',
    }

    const resetState = () => {
        setProfiles([])
        setReviewPassedRefs([])
        setReviewFailedRefs([])
        setImageUpdates([])
        setApiPageChange(1)
    }

    const handleProfileStateTabChange = (name) => {
        setProfileStateTab(name);
        setApiPageChange(1);
    }

    const handleLeftNavAppChange = (name) => {
        resetState()
        setAppName(name)
    };

    const getUsers = async () => {
        setIsLoading(true)
        let params = { page: apiPageChange, profile_state: profileState[profileStateTab] }
        let response = await authorizedHttpGet(urls.GET_FEED, params)
        if (response.status) {
            setProfiles(response.data.profile_list)
            if (response.data.profile_list.length > 0) {
                setReviewPassedRefs(response.data.profile_list.map(item => item.ref))
            }
            totalPagesApi.current = response.data.total_pages
            totalProfiles.current = response.data.total_profiles
        }
        setIsLoading(false)
    }

    const handleAction = (ref) => {
        if (reviewPassedRefs.includes(ref)) {
            setReviewPassedRefs(reviewPassedRefs.filter(item => item !== ref))
            setReviewFailedRefs([...reviewFailedRefs, ref])
        } else if (reviewFailedRefs.includes(ref)) {
            setReviewFailedRefs(reviewFailedRefs.filter(item => item !== ref))
            setReviewPassedRefs([...reviewPassedRefs, ref])
        }
    }

    const saveResults = async () => {
        setIsLoading(true)
        let data = {
            "review_failed_refs": reviewFailedRefs,
            "review_passed_refs": reviewPassedRefs,
            "image_updates": imageUpdates
        }
        let response = await authorizedHttpPost(urls.POST_FEED, data)
        if (response.status) {
            setReviewFailedRefs([])
            setReviewPassedRefs([])
            if (apiPageChange < totalPagesApi.current) {
                getUsers()
            }
        }
        setIsLoading(false);
    }

    const handleDetailedView = (ref) => {
        setIsDetailedView(true)
        localStorage.setItem('detailViewRef', ref)
    }

    const closeDetailedView = () => {
        setIsDetailedView(false)
        localStorage.removeItem('detailViewRef')
    }

    useEffect(() => {
        closeDetailedView()
    }, [appName])



    useEffect(() => {
        getUsers()
    }, [apiPageChange, profileStateTab, appName]);

    const goToPage = (pageModalNumber) => {
        setDisplayPageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    const openGoogleImages = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl);
        window.open('https://www.google.com/imghp', '_blank');
    }

    const saveCroppedImage = (croppedImage) => {
        let index = localStorage.getItem('feedPhotoIndex');
        let ref = localStorage.getItem('feedRef');
        let profile = profiles.filter(profile => profile.ref === ref)
        let profileImages = profile[0].photos;
        profileImages[index] = { photo: croppedImage }
        setProfiles([...profiles]);
        localStorage.removeItem('feedPhotoIndex');
        localStorage.removeItem('feedRef');
        setCropPhoto('');
        setShowCropImage(false);

        imageUpdates.filter(item => item.ref === ref).length > 0 ?
            imageUpdates.map(item => {
                if (item.ref === ref) {
                    item.photos[index] = { photo: croppedImage }
                }
            }) :
            setImageUpdates([...imageUpdates, { ref: ref, photos: profileImages }])
    }

    const showImageCrop = (photo, i, ref) => {
        setCropPhoto(photo.photo);
        setShowCropImage(true);
        localStorage.setItem('feedPhotoIndex', i);
        localStorage.setItem('feedRef', ref);
    }


    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Feed'} />
            {
                isLoading ? <Loader /> : (isDetailedView ? (<FeedDetailedProfileView closeDetailedView={closeDetailedView} afterSave={() => { }} />) :
                    <>
                        <ParentDiv>
                            {displayPageModal && <PageModal closeModal={() => setDisplayPageModal(false)} goToPage={goToPage} page={apiPageChange} />}
                            {showCropImage ? <CropImage photo={cropPhoto} closeModal={() => setShowCropImage(false)} saveCroppedImage={saveCroppedImage} /> : null}
                            <FlexWrapper className='marginTop25'>
                                <HeaderWrapper className='cursorPointer' onClick={() => setDisplayPageModal(true)}>
                                    <HeaderSelected>{apiPageChange}</HeaderSelected>
                                    <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                                    <HeaderSelected className='marginLeft10'>{totalProfiles.current}</HeaderSelected>
                                </HeaderWrapper>
                            </FlexWrapper>
                            <FlexWrapper>
                                <div className='headerWrapperDiv headerWrapperFeed'>
                                    <HeaderTextView marginRight cursor selected={profileStateTab === 'Approve'} onClick={() => handleProfileStateTabChange('Approve')}>Approved</HeaderTextView>
                                    <HeaderTextView marginRight cursor selected={profileStateTab === 'Disapprove'} onClick={() => handleProfileStateTabChange('Disapprove')}>Disapproved</HeaderTextView>
                                    <HeaderTextView marginRight cursor selected={profileStateTab === 'Inapropriate'} onClick={() => handleProfileStateTabChange('Inapropriate')}>Inapropriated</HeaderTextView>
                                </div>
                            </FlexWrapper>
                        </ParentDiv>
                        {
                            profiles.length > 0 ? (
                                <>
                                    <GapView height="30px" />
                                    <div className={!isIpad ? "profileInfoDivFeed" : "profileInfoDivFeedIpad"}>

                                        {profiles.map((profile, pos) => {
                                            return (
                                                <ProfileItemWrapper key={profile.ref}>
                                                    <div className='displayFlex'>
                                                        {
                                                            profile.photos.map((photo, i) => {
                                                                return (
                                                                    <ImageDivFeedParent
                                                                        rectangle={false}
                                                                        key={photo.photo + i}
                                                                    >
                                                                        <ImageDivFeed
                                                                            rectangle={false}
                                                                            src={photo.photo}
                                                                            onError={e => {
                                                                                e.target.src = placeholder_image;
                                                                            }}
                                                                        />
                                                                        <ChromeImageParent onClick={() => openGoogleImages(photo.photo)} src={chrome_icon} />
                                                                        {/* <RotatImageIcon
                                                                            src={cropImage}
                                                                            onClick={() => showImageCrop(photo, i, profile.ref)}
                                                                        /> */}

                                                                    </ImageDivFeedParent>
                                                                );
                                                            })}
                                                    </div>
                                                    <div>
                                                        {(profile.selfie_url || profile.gesture_url) && <ImageDivFeed
                                                            rectangle={false}
                                                            src={profile.selfie_url || profile.gesture_url}
                                                            onError={e => {
                                                                e.target.src = placeholder_image;
                                                            }}
                                                        />}
                                                    </div>
                                                    <div>
                                                        <GenderView male={profile.gender === 'Male'} />
                                                        <SelectedView
                                                            selected={reviewFailedRefs.includes(profile.ref)}
                                                            onClick={() => handleAction(profile.ref)}
                                                        >
                                                            {reviewFailedRefs.includes(profile.ref) ? 'X' : ''}
                                                        </SelectedView>
                                                    </div>
                                                    <NameWrapper>
                                                        <CommonTextStyle
                                                            cursor
                                                            highlight
                                                            onClick={detailedProfileViewPermission.includes(accessLevel) ? () => handleDetailedView(profile.ref) : null}
                                                        >
                                                            {profile.first_name}
                                                        </CommonTextStyle>
                                                        <CommonTextStyle>{profile.ref}</CommonTextStyle>
                                                    </NameWrapper>

                                                </ProfileItemWrapper>

                                            );
                                        })}
                                        <GapView height="30px" />
                                        <BottomBarWrapper>
                                            {apiPageChange === 1 ? <img src={previous_inctive} className='previousInactive' /> : <img src={previous_active} className='previousInactive' onClick={() => setApiPageChange(apiPageChange - 1)} />}
                                            {apiPageChange === totalPagesApi.current ? <img src={next_inactive} className='cursorPointer' /> : <img src={next_active} className='cursorPointer' onClick={() => setApiPageChange(apiPageChange + 1)} />}
                                            <BaseButton className='floatRight' onClick={() => saveResults()}>Save</BaseButton>
                                        </BottomBarWrapper>

                                    </div>
                                </>
                            ) : <EmptyView />
                        }
                    </>
                )
            }
        </div>
    );
}

export default Feed;